module.exports = __webpack_public_path__ + "img/blob-3.7d93c1ff.png";